// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getById, getDataView } from "@insite/client-framework/Store/Data/DataState";
import { GetBackOrdersApiParameter } from "@store/Framework/Services/BackOrderService";
import { createContext } from "react";

export function getBackOrdersState(state: ApplicationState, orderNumber: string | undefined) {
    return getById(state.store.data.backOrders, orderNumber, id => state.store.data.backOrders.idByBackOrderNumber[id]);
}

export function getBackOrdersDataView(state: ApplicationState, getBackOrdersParameter: GetBackOrdersApiParameter) {
    return getDataView(state.store.data.backOrders, getBackOrdersParameter);
}

export const BackOrdersDataViewContext = createContext<ReturnType<typeof getBackOrdersDataView>>({
    value: undefined,
    isLoading: false,
});

export const BackOrderStateContext = createContext<ReturnType<typeof getBackOrdersState>>({
    value: undefined,
    isLoading: false,
    errorStatusCode: undefined,
    id: undefined,
});

export const getBackOrdersParameter = (state: ApplicationState) => {
    return state.store.pages.backOrders.getBackOrdersParameter;
};

export const getDeleteModalIsOpen = (state: ApplicationState) => {
    return state.store.data.backOrders.deleteModalIsOpen;
};

export const getUpdateModalIsOpen = (state: ApplicationState) => {
    return state.store.data.backOrders.updateModalIsOpen;
};

export const getPendingQuantity = (state: ApplicationState) => {
    return state.store.data.backOrders.pendingQuantity;
};

export const getSelectedBackOrderItem = (state: ApplicationState) => {
    return state.store.data.backOrders.selectedBackOrderItem;
};
